module.exports = __webpack_public_path__ + "static/media/reservation.652df1a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/food/reservation.jpg
// module id = 676
// module chunks = 0